<!-- 
  定时话费流量话费充值
  lovi 2020-07-30
 -->
<template>
  <div class="recharge">
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>
          {{
            taskListFlag
              ? $t("recharge.timingRechargeTask")
              : $t("recharge.timingRecharge")
          }}
        </BreadcrumbItem>
      </Breadcrumb>
      <a class="returnA" @click="returnFun" v-if="nextStepFlag || taskListFlag">
        {{ $t("common.back") }}
      </a>
    </div>
    <div class="recharge-type" v-if="!nextStepFlag && !taskListFlag">
      <div class="type-item">
        <a
          href="javascript:void(0);"
          :class="{ active: rechargeType == 0 }"
          @click="changeType(0)"
          >{{ $t("recharge.timingBatchPhoneFee") }}</a
        >
        <a
          href="javascript:void(0);"
          :class="{ active: rechargeType == 1 }"
          @click="changeType(1)"
          >{{ $t("recharge.timingBatchDataTraffic") }}</a
        >
      </div>
      <a class="text-orange" @click="taskListFlag = true">{{
        $t("recharge.timingRechargeTask")
      }}</a>
    </div>

    <div class="recharge-content" v-if="!taskListFlag">
      <template v-if="!nextStepFlag">
        <number-enter
          ref="numberEnter"
          v-for="(item, index) in numberInfo"
          :key="index"
          :rechargeType="rechargeType"
          :operatorTitle="item.title"
          :operatorType="item.type"
          :tagList.sync="tagList"
          :operatorList="operatorList"
          :allMoney="allMoney"
        />
        <div class="button-wrap">
          <Button type="primary" long @click="nextStep">
            {{ $t("common.nextStep") }}
          </Button>
          <p>{{ $t("recharge.rechargeLimitTips") }}</p>
        </div>
      </template>
      <template v-if="nextStepFlag">
        <number-list
          v-if="nextStepFlag"
          :nextStepFlag.sync="nextStepFlag"
          :rechargeType="rechargeType"
          :numberList.sync="numberList"
          :operatorState="operatorState"
          :curPay.sync="curPay"
          :taskTimingFlag="true"
          :taskInfo="taskInfo"
          @getParams="getParams"
        />
      </template>
    </div>
    <task-list v-if="taskListFlag" @getTaskInfo="getTaskInfo" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import NumberEnter from "@/components/recharge/numberEnter";
import NumberList from "@/components/recharge/numberList";
import TaskList from "./taskList";
export default {
  name: "recharge-timing",
  components: {
    NumberEnter,
    NumberList,
    TaskList
  },
  data() {
    return {
      operatorList: [], //运营商列表
      numberInfo: [],
      numberList: [], //下一步展示的号码列表
      phoneBatch: [], //号码验证运营商数组
      phoneBatchInfo: {}, //页面信息,仅流量
      tagList: [], //电话簿标签列表

      operatorState: {}, // 运营商支持流量套餐状态
      allMoney: {}, // 全部金额面板
      curPay: {}, // 支付方式
      rechargeParams: {}, // 充值参数
      payMentInfo: {}, // 支付信息

      rechargeType: 0, //充值类型，0为话费，1为流量
      taskListFlag: false,
      taskEditFlag: false,
      taskInfo: {}, //定时任务信息  开关和日期
      nextStepFlag: false //下一步
    };
  },
  created() {
    let vm = this;
    vm.getFetchOperatorPre();
    vm.getCallsDenomination();
    vm.operatorDataPackageState();
    vm.getUserMobileTags();
    vm.initialize();
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    initialize() {
      //初始化信息
      let vm = this;
      vm.numberInfo = [];
      if (vm.rechargeType == 1) {
        for (let i = 0; i < 2; i++) {
          let obj = {};
          obj.title = [];
          obj.type = i + 1;
          obj.list = [];
          if (i == 0) {
            obj.title = ["Globe", "Smart", "Sun", "Tm"];
          } else {
            obj.title = ["Tnt"];
          }
          vm.numberInfo.push(obj);
        }
      } else {
        let obj = {};
        obj.title = [];
        obj.type = 0;
        obj.list = [];
        vm.numberInfo.push(obj);
      }
      console.log("numberInfo", vm.numberInfo);
    },
    getTaskInfo(data) {
      //获取任务数据
      let vm = this;
      vm.rechargeType = data.type == 20 ? 0 : 1;
      vm.numberList = JSON.parse(data.params);
      if (data.type == 20) {
        for (let i = 0; i < vm.numberList.length; i++) {
          let index = vm.numberList[i].operator_id;
          let obj = {};
          obj = vm.numberList[i];
          obj.denomination = vm.allMoney[index].denomination;
          obj.operator_recharge = vm.allMoney[index].operator_recharge;
          obj.recently = vm.allMoney[index].previous_record;
          vm.$set(vm.numberList, i, obj);
        }
      }
      console.log("numberList", vm.numberList);
      vm.taskInfo = data;
      console.log("taskInfo", data);
      vm.taskListFlag = false;
      vm.taskEditFlag = true;
      vm.nextStepFlag = true;
    },
    changeType(type) {
      //修改充值类别
      let vm = this;
      vm.rechargeType = type;
    },
    returnFun() {
      //返回按钮
      let vm = this;
      if (vm.taskEditFlag) {
        vm.taskEditFlag = false;
        vm.nextStepFlag = false;
        vm.taskListFlag = true;
        return;
      }
      if (vm.taskListFlag) {
        vm.taskListFlag = false;
        return;
      }
      if (vm.nextStepFlag) {
        vm.nextStepFlag = false;
      }
    },
    nextStep() {
      //点击下一步
      let vm = this;
      let inputDate = [];
      for (let i = 0; i < vm.$refs.numberEnter.length; i++) {
        //vm.$refs.number[i].getClassify()调用number组件的getClassify()方法，获取输入的号码数据
        inputDate.push(vm.$refs.numberEnter[i].getClassify());
      }
      //判断当前是否有号码
      let hasNum = false;
      for (let i = 0; i < inputDate.length; i++) {
        if (inputDate[i].arr.length) {
          hasNum = true;
          break;
        }
      }
      if (!hasNum) {
        vm.$Message.info(vm.$t("common.enterMobile"));
        return false;
      }
      //判断是否有错误号码
      let hasError = false;
      for (let i = 0; i < inputDate.length; i++) {
        if (inputDate[i].error) {
          hasError = true;
          break;
        }
      }
      if (hasError) {
        vm.$Modal.confirm({
          content: vm.$t("recharge.wrongNumberTips"),
          onOk: () => {
            for (let i = 0; i < inputDate.length; i++) {
              if (inputDate[i].error) {
                //去错去重
                vm.$refs.numberEnter[i].deleteSubmit(0);
              }
            }
          }
        });
        return;
      }
      //判断是否有重复号码
      let hasRepeat = false;
      for (let i = 0; i < inputDate.length; i++) {
        if (inputDate[i].repeat) {
          hasRepeat = true;
          break;
        }
      }
      if (hasRepeat) {
        vm.$Modal.confirm({
          content: vm.$t("recharge.duplicateNumberTips"),
          onOk: () => {
            inputDate = [];
            for (let i = 0; i < vm.$refs.numberEnter.length; i++) {
              inputDate.push(vm.$refs.numberEnter[i].getClassify(true));
            }
            vm.numberProcessing(inputDate);
          }
        });
        return;
      }
      vm.numberProcessing(inputDate);
    },
    numberProcessing(inputDate) {
      // 号码列表处理
      let vm = this;
      vm.numberList = [];
      for (let i = 0; i < inputDate.length; i++) {
        if (!inputDate[i].arr.length) {
          continue;
        }
        for (let j = 0; j < inputDate[i].arr.length; j++) {
          vm.numberList.push(inputDate[i].arr[j]);
        }
      }
      console.log("numberList", vm.numberList);
      vm.nextStepFlag = true;
    },
    getParams(data) {
      // 获取充值参数
      let vm = this;
      console.log("getParams", data);
      vm.rechargeParams = data;
      vm.setTimes();
    },
    setTimes() {
      // 配置定时任务
      let vm = this;
      let params = {};
      params = vm.rechargeParams;
      vm.$post("/app/recharge/setTimes", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("setTimes", res);
        if (res.code == 0) {
          vm.$Message.success(res.msg);
          if (vm.taskInfo.timer_id) {
            vm.taskListFlag = true;
          }
          vm.taskInfo = {};
          vm.nextStepFlag = false;
        } else {
          vm.$Message.error(res.msg);
        }
      });
    },
    getUserMobileTags() {
      // 电话簿标签列表
      let vm = this;
      vm.$post("/app/user/userMobileTags", {}, { loading: true }).then(res => {
        console.log("userMobileTags", res);
        vm.tagList = res.list;
      });
    },
    operatorDataPackageState() {
      // 运营商支持流量套餐状态
      let vm = this;
      vm.$post(
        "/app/recharge/operatorDataPackageState",
        {},
        { loading: true }
      ).then(res => {
        console.log("operatorDataPackageState", res);
        vm.operatorState = res;
      });
    },
    getCallsDenomination() {
      // 话费充值面板
      let vm = this;
      vm.$post(
        "/app/recharge/callsDenomination",
        { type: 20 },
        { loading: true }
      ).then(res => {
        console.log("callsDenomination", res);
        vm.allMoney = res.list;
      });
    },
    getFetchOperatorPre() {
      //获取运营商字段
      let vm = this;
      vm.$post(
        "/app/index/fetchOperatorPre",
        {},
        {
          loading: true
        }
      ).then(res => {
        console.log("fetchOperatorPre", res);
        vm.operatorList = res.list;
      });
    }
  },
  watch: {
    rechargeType() {
      this.initialize();
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.recharge-type {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #bfbfbf;
  .type-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    a {
      height: 45px;
      font-size: 18px;
      color: #4a4a4a;
      display: flex;
      align-items: center;
      &.active {
        color: #2042ab;
        position: relative;
        &:after {
          content: "";
          width: 100%;
          height: 4px;
          border-radius: 2px;
          background: #2042ab;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
    a + a {
      margin-left: 50px;
    }
  }
  .text-orange {
    font-size: 14px;
    color: #fe7800;
  }
}

.recharge-content {
  padding: 30px 50px;
}
</style>
